import React, { useState, useEffect } from "react";
import "./Payslip.css";

export default function GeneratePaySlip(){
     const [employees, setEmployees] = useState([]);
     const [config, setConfig] = useState(null);
     const [selectedEmployee, setSelectedEmployee] = useState(null);
     const [basicSalary, setBasicSalary] = useState("");
    const [allowances, setAllowances] = useState("");
    const [pf, setPf] = useState("");
    const [tax, setTax] = useState("");
    const [month, setMonth] = useState("");
    const[incentivepay,setIncentivepay]=useState("");
    const[transactionid,setTransactionid]=useState("");
    const [payslips, setPayslips] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterMonth, setFilterMonth] = useState("");
    const [filterDept, setFilterDept] = useState("");




      useEffect(() => {
        fetch("/config.json")
          .then((res) => res.json())
          .then((data) => setConfig(data))
          .catch((err) => console.error("Config fetch error:", err));
      }, []);
    
      // Fetch employees
      useEffect(() => {
        if (!config) return;
        const fetchEmployees = async () => {
          try {
            const response = await fetch(`${config.BASE_URL}${config.GET_NOEMPLOYEE}`, {
              method: "POST",
              credentials: "include",
              headers: { "X-Requested-With": "RC_EMP_NEW" },
              body: JSON.stringify({}) 
            });
            const data = await response.json();
            setEmployees(data.status === "success" ? data.data || [] : []);
          } catch (error) {
            console.error("Fetch employees failed:", error);
          }
        };
        fetchEmployees();
      }, [config]);

      const handleGenerate = async () => {
            if (!selectedEmployee || !basicSalary || !month || !transactionid) {
                alert("Please fill all mandatory fields.");
                return;
            }

            const payload = {
                emp_code: selectedEmployee.emp_code,
                salary: basicSalary,
                pay_period: month,
                transaction_id: transactionid,
                incentive_pay: parseValue(incentivepay),
                allowances: parseValue(allowances),
                pf: parseValue(pf),
                tax: parseValue(tax),
            };

            try {
                const response = await fetch(`${config.BASE_URL}${config.GENERATE_PAYSLIP}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "RC_EMP_NEW"
                },
                body: JSON.stringify(payload)
                });

                const data = await response.json();

                if (data.status === "success") {
                alert("Payslip generated successfully!");
                window.location.reload(); 
                // Optional: Reset form
                setBasicSalary("");
                setAllowances("");
                setPf("");
                setTax("");
                setMonth("");
                setIncentivepay("");
                setTransactionid("");
                } else {
                alert(data.message || "Failed to generate payslip");
                }

            } catch (error) {
                console.error("Generate payslip failed:", error);
                alert("Server error");
            }
            };

            // Convert input to number based on % or plain number
            const parseValue = (input) => {
            if (!input) return 0;
            input = input.toString().trim();
            if (input.endsWith("%")) {
                let percent = parseFloat(input.replace("%", ""));
                return (basicSalary ? parseFloat(basicSalary) : 0) * percent / 100;
            } else {
                return parseFloat(input);
            }
            };

            useEffect(() => {
  if (!config) return;

  const fetchPayslips = async () => {
    try {
      const response = await fetch(
        `${config.BASE_URL}${config.GET_PAYSLIP_DETAILS}`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "RC_EMP_NEW",
          },
          body: JSON.stringify({})
        }
      );

      const data = await response.json();
      setPayslips(data.status === "success" ? data.data || [] : []);
    } catch (error) {
      console.error("Fetch payslips failed:", error);
    }
  };

  fetchPayslips();
}, [config]);

const filteredPayslips = payslips.filter((p) => {
  const matchesSearch =
    p.emp_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.name.toLowerCase().includes(searchTerm.toLowerCase());

  const matchesMonth =
    filterMonth ? p.pay_period === filterMonth : true;

  const matchesDept =
    filterDept ? p.department === filterDept : true;

  return matchesSearch && matchesMonth && matchesDept;
});



      return(
        <>
        <div>
             <div className="dropdown-container">
          <label>Employee:</label>
          <select
            value={selectedEmployee?.emp_code || ""}
            onChange={(e) => {
                const emp = employees.find(emp => emp.emp_code === e.target.value);
                setSelectedEmployee(emp);
            }}
            >
            <option value="">-- Select Employee --</option>
            {employees.map((emp) => (
                <option key={emp.emp_code} value={emp.emp_code}>
                {emp.emp_code} - {emp.name} ({emp.role} - {emp.department})
                </option>
            ))}
            </select>

        </div>
        </div>

        {selectedEmployee && (
        <div className="payslip-form">
            <h3>Generate Payslip for {selectedEmployee.name} ({selectedEmployee.emp_code})</h3>

              <div className="form-group">
                <label>Designation *</label>
                <input
                    type="text"
                    value={selectedEmployee.role || "-"}
                    disabled
                />
                </div>

                <div className="form-group">
                <label>Department *</label>
                <input
                    type="text"
                    value={selectedEmployee.department || "-"}
                    disabled
                />
                </div>

                <div className="form-group">
                <label>Joining Date*</label>
                <input
                    type="date"
                    value={selectedEmployee?.joining_date?.slice(0, 10) || ""}
                    disabled
                />
                </div>

            <div className="form-group">
            <label>Pay Period*</label>
            <input
                type="month"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
            />
            </div>

            <div className="form-group">
            <label>Basic Pay *</label>
            <input
                type="number"
                value={basicSalary}
                onChange={(e) => setBasicSalary(e.target.value)}
            />
            </div>

            <div className="form-group">
            <label>Transaction Id*</label>
            <input
                type="text"
                value={transactionid}
                onChange={(e) => setTransactionid(e.target.value)}
            />
            </div>

             <div className="form-group">
            <label>Incentive Pay</label>
            <input
                type="text"                
                value={incentivepay}
                onChange={(e) => setIncentivepay(e.target.value)}
                placeholder="Amount or %"
            />
            </div>


            <div className="form-group">
            <label>Allowances</label>
            <input
                type="text"
                value={allowances}
                onChange={(e) => setAllowances(e.target.value)}
                placeholder="Amount or %"
            />
            </div>

           <div className="form-group">
            <label>Deductions</label>

          
                <div className="form-group">
                <label>PF</label>
                <input
                    type="text"
                    value={pf}
                    onChange={(e) => setPf(e.target.value)}
                    placeholder="Amount or %"
                />
               

                <div className="form-group">
                <label>Tax</label>
                <input
                    type="text"
                    value={tax}
                    onChange={(e) => setTax(e.target.value)}
                    placeholder="Amount or %"
                />
                </div>
            </div>
            </div>

            <button 
            className="generate-btn"
            onClick={handleGenerate}
            >
            Generate Payslip
            </button>

        </div>
        )}

        <div className="payslip-table">
      <h3>Generated Payslips</h3>
        <div className="table-filters">

        <input
            type="text"
            placeholder="Search by Emp Code or Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
        />

        <input
            type="month"
            value={filterMonth}
            onChange={(e) => setFilterMonth(e.target.value)}
        />

        <select
            value={filterDept}
            onChange={(e) => setFilterDept(e.target.value)}
        >
            <option value="">All Departments</option>
            {[...new Set(payslips.map(p => p.department))].map((dept, i) => (
            <option key={i} value={dept}>
                {dept}
            </option>
            ))}
        </select>

        </div>

  <table>
    <thead>
      <tr>
        <th>Emp Code</th>
        <th>Name</th>
        <th>Department</th>
        <th>Role</th>
        <th>Pay Period</th>
        <th>Basic Pay</th>
        <th>Total Pay(including allowances & Deductions)</th>
        <th>Generated At</th>
      </tr>
    </thead>
    <tbody>
      {filteredPayslips.length > 0 ? (
  filteredPayslips.map((p, index) => {

          const totalPay =
            parseFloat(p.salary || 0) +
            parseFloat(p.incentive_pay || 0) +
            parseFloat(p.allowances || 0) -
            parseFloat(p.pf || 0) -
            parseFloat(p.tax || 0);

          return (
            <tr key={index}>
              <td>{p.emp_code}</td>
              <td>{p.name}</td>
              <td>{p.department}</td>
              <td>{p.role}</td>
              <td>{p.pay_period}</td>
              <td>{p.salary}</td>
              <td>{totalPay.toFixed(2)}</td>
              <td>{p.created_at?.slice(0, 19).replace("T"," ")}</td>
              
            </tr>
          );
        })
      ) : (
        <tr>
          <td colSpan="8">No payslips found.</td>
        </tr>
      )}
    </tbody>
  </table>
</div>

</>
      );

};